export interface FAQ {
  id: string;
  question: string;
  answer: string;
  category: string;
}

export const faqs: FAQ[] = [
  {
    id: 'faq-1',
    question: 'jm天堂是什么？',
    answer: 'jm天堂是一个深受用户喜爱的内容资源平台，提供丰富多样的内容资源，涵盖多个分类领域。平台以优质的资源质量和良好的用户体验著称，拥有庞大的用户群体。通过本官方网站，您可以获取最新的官方入口地址、使用教程和常见问题解答。',
    category: '平台介绍',
  },
  {
    id: 'faq-2',
    question: '如何获取jm天堂最新官方入口地址？',
    answer: '获取jm天堂最新官方入口地址最可靠的方式是收藏本官方网站（jmtiantang-official.com）。我们的团队会第一时间更新最新地址信息。此外，您也可以关注官方公告和加入官方社群获取实时通知。请务必通过官方渠道获取地址，避免使用来路不明的链接，确保账号安全。',
    category: '访问相关',
  },
  {
    id: 'faq-3',
    question: 'jm天堂需要付费吗？',
    answer: 'jm天堂平台提供基础免费服务，用户注册后即可浏览和使用核心功能。同时，平台也提供高级会员服务，会员用户可以享受更多专属权益，包括更高清的观看体验、去广告服务、专属内容推荐等。具体费用和权益详情请登录平台后在会员中心查看。',
    category: '账号相关',
  },
  {
    id: 'faq-4',
    question: '忘记jm天堂账号密码怎么办？',
    answer: '如果您忘记了jm天堂账号的密码，可以在登录页面点击"忘记密码"链接。系统会向您注册时绑定的邮箱发送密码重置链接。按照邮件中的指引操作即可重新设置密码。如果收不到重置邮件，请检查垃圾邮件文件夹，或确认您输入的邮箱地址是否正确。',
    category: '账号相关',
  },
  {
    id: 'faq-5',
    question: 'jm天堂支持哪些设备访问？',
    answer: 'jm天堂支持多种设备访问，包括：Windows和macOS电脑（推荐使用Chrome、Edge、Firefox等主流浏览器）、iOS和Android手机和平板（通过移动浏览器访问）、部分智能电视设备。平台界面会自动适配不同屏幕尺寸，确保各设备上的浏览体验。',
    category: '使用相关',
  },
  {
    id: 'faq-6',
    question: '如何提高jm天堂的访问速度？',
    answer: '如果您在使用jm天堂时遇到加载缓慢的情况，可以尝试以下方法提高访问速度：1）使用稳定的网络连接；2）选择网络使用低峰时段访问；3）清除浏览器缓存和Cookie；4）关闭其他占用带宽的应用程序；5）尝试更换网络环境（如从移动数据切换到Wi-Fi）。',
    category: '使用相关',
  },
  {
    id: 'faq-7',
    question: 'jm天堂平台的内容多久更新一次？',
    answer: 'jm天堂平台的内容更新频率较高，具体更新节奏因内容分类而异。热门推荐栏目每日更新，最新上架栏目实时更新，精选合集栏目每周更新，其他分类也保持定期更新。您可以在平台首页查看最新上架的内容，或关注您感兴趣的分类以获取更新通知。',
    category: '内容相关',
  },
  {
    id: 'faq-8',
    question: '如何保护jm天堂账号安全？',
    answer: '保护jm天堂账号安全，建议您：1）设置强密码（至少12位，包含大小写字母、数字和特殊字符）；2）开启两步验证功能；3）绑定安全邮箱以便接收登录提醒；4）不要在公共设备上保存登录状态；5）定期更换密码；6）警惕钓鱼网站，仅通过官方入口访问平台。',
    category: '安全相关',
  },
  {
    id: 'faq-9',
    question: 'jm天堂账号被盗了怎么办？',
    answer: '如果您发现jm天堂账号出现异常登录或信息被篡改的情况，请立即采取以下措施：1）通过绑定的安全邮箱重置密码；2）在账号设置中检查并下线可疑设备；3）检查并修改被篡改的个人信息；4）开启两步验证增加安全保护；5）联系平台客服报告情况，寻求进一步帮助。',
    category: '安全相关',
  },
  {
    id: 'faq-10',
    question: '如何联系jm天堂客服？',
    answer: '您可以通过以下方式联系jm天堂客服团队：1）访问本网站"关于我们"页面，使用联系表单提交您的问题；2）在jm天堂平台内使用在线客服功能；3）发送邮件至官方客服邮箱。我们的客服团队会在工作时间内尽快回复您的咨询。建议在联系客服时详细描述您遇到的问题，以便更快获得帮助。',
    category: '其他',
  },
  {
    id: 'faq-11',
    question: 'jm天堂支持内容下载吗？',
    answer: 'jm天堂平台的部分内容支持离线缓存功能，方便用户在网络不稳定或无网络环境下查看。缓存的内容可在平台内查看。具体的下载和缓存权限可能因内容类型和您的会员等级而有所不同。请注意，缓存内容仅供个人使用，请勿进行二次传播。',
    category: '内容相关',
  },
  {
    id: 'faq-12',
    question: 'jm天堂会员有哪些特权？',
    answer: 'jm天堂高级会员享有以下特权：1）去广告浏览体验；2）更高清的观看画质；3）专属内容推荐；4）优先体验新功能；5）更大的离线缓存空间；6）专属会员标识；7）参与会员专属活动。具体会员权益可能会根据平台政策调整，以平台内会员中心展示为准。',
    category: '账号相关',
  },
];